(function () {
  var root = document.querySelector('[data-pw-partners]');
  if (!root) return;

  var seoTitle = root.dataset.pwPartnersSeoTitle;
  var seoDescription = root.dataset.pwPartnersSeoDescription;
  var canonicalUrl = window.location.origin + '/pages/partners';

  function setMeta(attribute, key, value) {
    var selector = 'meta[' + attribute + '="' + key + '"]';
    var tag = document.head.querySelector(selector);
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute(attribute, key);
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', value);
  }

  if (seoTitle) document.title = seoTitle;
  if (seoDescription) {
    setMeta('name', 'description', seoDescription);
    setMeta('property', 'og:description', seoDescription);
    setMeta('name', 'twitter:description', seoDescription);
  }
  setMeta('property', 'og:title', seoTitle);
  setMeta('name', 'twitter:title', seoTitle);
  setMeta('property', 'og:url', canonicalUrl);
  var canonical = document.head.querySelector('link[rel="canonical"]');
  if (canonical) canonical.setAttribute('href', canonicalUrl);

  var items = Array.prototype.slice.call(root.querySelectorAll('[data-pw-partners-reveal]'));
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reducedMotion && 'IntersectionObserver' in window) {
    root.classList.add('pw-partners--js');
    items.forEach(function (item, index) {
      item.style.setProperty('--pw-partners-delay', Math.min((index % 4) * 60, 180) + 'ms');
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .1 });
    items.forEach(function (item) { observer.observe(item); });
  } else {
    items.forEach(function (item) { item.classList.add('is-visible'); });
  }

  if (!reducedMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var heroMedia = root.querySelector('.pw-partners__hero-media');
    if (heroMedia) {
      heroMedia.addEventListener('pointermove', function (event) {
        var rect = heroMedia.getBoundingClientRect();
        heroMedia.style.setProperty('--pw-light-x', ((event.clientX - rect.left) / rect.width * 100) + '%');
        heroMedia.style.setProperty('--pw-light-y', ((event.clientY - rect.top) / rect.height * 100) + '%');
      });
    }

    root.querySelectorAll('.pw-partners__tier').forEach(function (tier) {
      tier.addEventListener('pointermove', function (event) {
        var rect = tier.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width;
        var y = (event.clientY - rect.top) / rect.height;
        tier.style.setProperty('--pw-tilt-x', ((.5 - y) * 7).toFixed(2) + 'deg');
        tier.style.setProperty('--pw-tilt-y', ((x - .5) * 7).toFixed(2) + 'deg');
        tier.style.setProperty('--pw-card-x', (x * 100).toFixed(1) + '%');
        tier.style.setProperty('--pw-card-y', (y * 100).toFixed(1) + '%');
      });
      tier.addEventListener('pointerleave', function () {
        tier.style.setProperty('--pw-tilt-x', '0deg');
        tier.style.setProperty('--pw-tilt-y', '0deg');
      });
    });
  }

  var calculator = root.querySelector('[data-partner-calculator]');
  if (!calculator) return;

  var amount = calculator.querySelector('[data-partner-amount]');
  var rate = calculator.querySelector('[data-partner-rate]');
  var commission = calculator.querySelector('[data-partner-commission]');
  var formatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });

  function updateCalculator() {
    var projectAmount = Math.max(0, Number(amount.value) || 0);
    var commissionRate = Math.max(0, Number(rate.value) || 0);
    var partnerCommission = projectAmount * commissionRate / 100;
    commission.textContent = formatter.format(partnerCommission);
    root.querySelectorAll('[data-partner-tier]').forEach(function (tierButton) {
      tierButton.closest('.pw-partners__tier').classList.toggle('is-selected', tierButton.dataset.partnerTier === rate.value);
    });
  }

  amount.addEventListener('input', updateCalculator);
  rate.addEventListener('change', updateCalculator);
  root.querySelectorAll('[data-partner-tier]').forEach(function (tierButton) {
    tierButton.addEventListener('click', function () {
      rate.value = tierButton.dataset.partnerTier;
      updateCalculator();
      calculator.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
    });
  });
  updateCalculator();
})();
